module.exports = __webpack_public_path__ + "static/ishmael-612849a3d95a99a274ee35167e55bc18.jpg";